<script lang="ts">
	import { createEventDispatcher } from 'svelte'

	import { STATUS_PILL_SIZES, STATUS_PILL_TYPES } from './StatusPill_types'
	const dispatch = createEventDispatcher()

	export let type: STATUS_PILL_TYPES = STATUS_PILL_TYPES.DEFAULT
	export let size: STATUS_PILL_SIZES = STATUS_PILL_SIZES.SM
	export let text = ''

	$: class_type = 'type_' + type
	$: class_size = 'size_' + size

	const handleClick = () => {
		dispatch('click')
	}
</script>

<div
	class="common {class_type} {class_size}"
	{...$$restProps}
	on:click|preventDefault|stopPropagation={() => handleClick()}
>
	{text}
</div>

<style lang="postcss">
	.common {
		/* @apply rounded-full px-2 flex-grow-0 border flex items-center justify-center min-w-[80px]; */
		@apply whitespace-nowrap;
		@apply inline-flex items-center justify-center;
		border-radius: 99px;
	}

	/* size */
	.size_xs {
		@apply text-xs;
		padding: 4px 8px;
	}
	.size_sm {
		@apply text-xs;
		padding: 6px 12px;
	}
	.size_md {
		@apply text-sm;
		padding: 8px 12px;
	}
	.size_lg {
		@apply text-base;
		padding: 8px 16px;
	}

	/* types style */
	.type_default {
		@apply bg-gray-100 text-gray-700;
	}
	.type_notice {
		@apply bg-blue-100 text-blue-700;
	}
	.type_success {
		@apply bg-emerald-100 text-emerald-700;
	}
	.type_warning {
		@apply bg-amber-100 text-amber-700;
	}
	.type_error {
		@apply bg-red-100 text-red-700;
	}

	/* status styles */
	/* .status_draft {
		@apply bg-blue-100 text-blue-700;
	}
	.status_sent {
		@apply bg-blue-100 text-blue-700;
	}
	.status_viewed {
		@apply bg-blue-100 text-blue-700;
	}
	.status_partial-paid {
		@apply bg-yellow-100 text-yellow-800;
	}
	.status_paid {
		@apply bg-green-100 text-green-700;
	}

	.status_approved {
		@apply bg-green-100 text-green-700;
	}

	.status_invoiced {
		@apply bg-green-100 text-green-700;
	}

	.status_loading {
		@apply bg-gray-100 text-gray-600;
	}
	.status_refunded {
		@apply bg-gray-100 text-gray-600;
	}
	.status_deleted {
		@apply bg-red-100 text-red-700;
	} */
</style>
